import { doc, setDoc, increment } from "firebase/firestore";
import { db } from "../firebase/config";
import { getTodayString } from "./session";

export async function incrementDailyMetric(date, field, amount = 1) {
  const safeDate = date || getTodayString();
  const ref = doc(db, "daily_metrics", safeDate);

  await setDoc(
    ref,
    {
      date: safeDate,
      [field]: increment(amount),
      updatedAt: new Date().toISOString(),
    },
    { merge: true }
  );
}

export async function addDailyTime(date, seconds) {
  const safeDate = date || getTodayString();
  const ref = doc(db, "daily_metrics", safeDate);

  await setDoc(
    ref,
    {
      date: safeDate,
      totalTimeSeconds: increment(seconds),
      totalTimeEvents: increment(1),
      updatedAt: new Date().toISOString(),
    },
    { merge: true }
  );
}